/** `/terms`: Общи условия. The text is in src/app/content/terms.tsx. */

import { ContentPage } from '../components/ContentPage.tsx'
import { TermsBg, TermsEn } from '../content/terms.tsx'

export function Terms() {
  return <ContentPage titleKey="terms.title" page="terms" bg={<TermsBg />} en={<TermsEn />} />
}
